import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { noop } from 'lodash';
import React from 'react';
import { ThemeContext } from 'styled-components'; // This should really be in cactus-theme...

export var screenSizes = ['tiny', 'small', 'medium', 'large', 'extraLarge'];
var ORDER = {
  tiny: 0,
  small: 1,
  medium: 2,
  large: 3,
  extraLarge: 4
};
export var ScreenSize = /*#__PURE__*/function () {
  function ScreenSize(size) {
    _classCallCheck(this, ScreenSize);

    this.size = void 0;
    this.size = size;
  }

  _createClass(ScreenSize, [{
    key: "toString",
    value: function toString() {
      return "".concat(this.size);
    }
  }, {
    key: "valueOf",
    value: function valueOf() {
      return ORDER[this.size] || -1;
    }
  }]);

  return ScreenSize;
}();
export var SIZES = screenSizes.reduce(function (sizes, s) {
  var size = new ScreenSize(s);
  sizes[ORDER[s]] = size;
  sizes[s] = size;
  return sizes;
}, []);

var ORDERED_SIZES = _toConsumableArray(SIZES).map(function (s) {
  return s.size;
}).reverse();

var DEFAULT_SIZE = 'large';
export var ScreenSizeContext = /*#__PURE__*/React.createContext(SIZES[DEFAULT_SIZE]);
export var useScreenSize = function useScreenSize() {
  return React.useContext(ScreenSizeContext);
};

var createQueries = function createQueries(theme) {
  return {
    tiny: {
      matches: true,
      addListener: noop,
      removeListener: noop,
      removeEventListener: noop,
      addEventListener: noop
    },
    small: window.matchMedia(theme.mediaQueries.small.replace(/^@media /, '')),
    medium: window.matchMedia(theme.mediaQueries.medium.replace(/^@media /, '')),
    large: window.matchMedia(theme.mediaQueries.large.replace(/^@media /, '')),
    extraLarge: window.matchMedia(theme.mediaQueries.extraLarge.replace(/^@media /, ''))
  };
};

var getMatchedSize = function getMatchedSize(queries) {
  var _iterator = _createForOfIteratorHelper(ORDERED_SIZES),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var size = _step.value;

      if (queries[size].matches) {
        return size;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return DEFAULT_SIZE;
};

export var ScreenSizeProvider = function ScreenSizeProvider(_ref) {
  var children = _ref.children;
  var queries = undefined;
  var theme = React.useContext(ThemeContext);

  var _React$useState = React.useState(function () {
    queries = createQueries(theme);
    return getMatchedSize(queries);
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      currentSize = _React$useState2[0],
      setSize = _React$useState2[1];

  React.useEffect(function () {
    var q = queries || createQueries(theme);

    var listener = function listener() {
      return setSize(getMatchedSize(q));
    };

    for (var _i = 0, _Object$keys = Object.keys(q); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];

      if (!('addEventListener' in q[key])) {
        q[key].addListener(listener);
      } else {
        q[key].addEventListener('change', listener);
      }
    }

    listener();
    return function () {
      for (var _i2 = 0, _Object$keys2 = Object.keys(q); _i2 < _Object$keys2.length; _i2++) {
        var _key = _Object$keys2[_i2];

        if (!('removeEventListener' in q[_key])) {
          q[_key].removeListener(listener);
        } else {
          q[_key].removeEventListener('change', listener);
        }
      }
    };
  }, [theme]); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/React.createElement(ScreenSizeContext.Provider, {
    value: SIZES[currentSize]
  }, children);
};
export default ScreenSizeProvider;